$(document).ready(function () {
    $('a.js-view-large').on('click', function () {
        var title = $('#hfArticleTitle').val();
        if (title != null && title != '') {
            title = encodeURIComponent(title);
        }
    });

});
